// extracted by mini-css-extract-plugin
export var button = "_e1-4";
export var hasDarkBackground = "_e1-7";
export var hasLightBackground = "_e1-6";
export var iconWrapper = "_e1-0";
export var large = "_e1-2";
export var medium = "_e1-1";
export var small = "_e1-5";
export var xsmall = "_e1-3";